// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.wrapper-right[data-v-7b994b5a]{font-weight:700;flex-basis:40%}.slide-fade-enter-active[data-v-7b994b5a]{transition:all .3s ease}.slide-fade-leave-active[data-v-7b994b5a]{transition:all .8s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-7b994b5a],.slide-fade-leave-to[data-v-7b994b5a]{transform:translateX(10px);opacity:0}", ""]);
// Exports
module.exports = exports;
